'use strict';

var dietTabsHead = '.diet-plan-tabs';
var dietTabsContent = '.diet-plan-tabs-content';
var dietTabsHeadSelector = '.diet-plan-tabs-item';
var dietTabsContentSelector = '.diet-timings-carousel';
var dietAccordionHeadSelector = '.diet-plan-accordion-title';

module.exports = function () {
    $(dietTabsHeadSelector).last().addClass('active');
    $(dietTabsContentSelector).last().parent().addClass('active');
    $(dietAccordionHeadSelector).parent().addClass('toggle-content');

    $(document).on('click', dietTabsHeadSelector, function () {
        $(dietTabsHeadSelector).removeClass('active');
        $(dietTabsContentSelector).parent().removeClass('active');

        $(dietTabsHeadSelector).eq($(this).index()).addClass('active');
        $(dietTabsContentSelector).eq($(this).index()).parent().addClass('active');
        $('body').trigger('init:diet-timings-carousel');
    });

    $(document).on('click', dietAccordionHeadSelector, function () {
        $(this).parent().toggleClass('active');
        $('body').trigger('init:diet-timings-carousel');
    });

    $(document).on('click', '.reviews-toggle', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).parent().next().find('.reviews-toggle-content').toggleClass('active');
    });
};
